import React from 'react';
import { twMerge } from 'tailwind-merge';

import { CHIP_BASE_CLASSES, getChipBackplateClass } from './chip-classes';

type Props = {
    label: string;
    isSelected: boolean;
    muted?: boolean;
};

const TagChip = ({ label, isSelected, muted }: Props) => (
    <div
        className={twMerge(
            CHIP_BASE_CLASSES,
            getChipBackplateClass(isSelected),
            // Tags get symmetric 8px padding rather than the chip default.
            'ps-2 pe-2',
            // Closed tickets: fade the tag text like the other pills.
            muted ? 'text-gray-500' : null,
        )}
    >
        {label}
    </div>
);

export default React.memo(TagChip);
